import React, { useState, useEffect } from "react";

export const BackofficeTools = () => {
  const isVisible = (elementOffset) => {
    return scrollY > elementOffset - window.innerHeight + 100;
  };

  return (
    <section className="py-20 px-4 relative bg-zinc-900 ">
      <div className="max-w-4xl mx-auto">
        <div
            className={`transform transition-all duration-1000 ${
                isVisible(800)
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-10"
            }`}
        >
          <h2 className="text-4xl/[1.5] font-bold text-center mb-8 text-[#FF4D00]">
            Create your festival app in minutes!
          </h2>
          <img
            src={require("../assets/helga_bo_and_app_alternative.jpg")}
            alt="Back office dashboard"
            className="w-full h-full"
          />
          <div className="text-center pt-8 ">
            <p>
              With Helga's powerful backoffice tools you can create your festival in minutes!
            </p>
            <p>
              All information will be available to your visitors in real time via the Helga Festival App!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
